import DesignSchemeController from './DesignSchemeController';
import MixerController from './MixerController';
import PipelineController from './PipelineController';
import RendererController from './RendererController';
import CameraController from './CameraController';
import StateController from './StateController';
import GridController from './GridController';

export class ControllerManager {
    private static instance: ControllerManager;

    private pipelineController = new PipelineController();
    private mixerController?: MixerController;
    private rendererController = new RendererController();
    private cameraController = new CameraController();
    private designSchemeController?: DesignSchemeController;
    private stateController = new StateController();
    private gridController = new GridController();

    // Private constructor prevents external instantiation
    private constructor() {
        // initialize your controller manager logic here
    }

    // Public static accessor for the single instance
    public static getInstance(): ControllerManager {
        if (!ControllerManager.instance) {
            ControllerManager.instance = new ControllerManager();
        }
        return ControllerManager.instance;
    }

    public getPipelineController(): PipelineController {
        return this.pipelineController;
    }

    public getRendererController(): RendererController {
        return this.rendererController;
    }

    public getCameraController(): CameraController {
        return this.cameraController;
    }

    public getStateController(): StateController {
        return this.stateController;
    }

    public getGridController(): GridController {
        return this.gridController;
    }

    public getMixerController(): MixerController {
        if (!this.mixerController) {
            this.mixerController = new MixerController();
        }
        return this.mixerController;
    }

    public getDesignSchemeController(): DesignSchemeController {
        if (!this.designSchemeController) this.designSchemeController = new DesignSchemeController();
        return this.designSchemeController;
    }

    public destroyMixerController(): void {
        this.mixerController?.destroy();
        this.mixerController = undefined;
    }
}
